export default {
  oops: "Oops! We've gone in circles!",
  error: '500 - Unexpected Error',
  errorDetails: "Something went terribly wrong. Looks like it's not your fault... or is it?",
}
